const PLAYER = {
  resources: {
    energy: 100,
    gold: 0,
    stars: 0
  },
  
  lastEnergyReplenish: Date.now(),
  maxEnergy: 100,
  
  buildings: null,
  decorations: null,
  
  storyBeatsShown: [],
  
  rewardQueue: [],
  
  completedLevels: [],
  
  name: "Captain",
  avatarEmoji: "🏴‍☠️",
  
  inventory: []
};

export default PLAYER;
